import { render, staticRenderFns } from "./resultDetail.vue?vue&type=template&id=8e798ba8&scoped=true"
import script from "./resultDetail.vue?vue&type=script&lang=js"
export * from "./resultDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/user/resultDetail.css?vue&type=style&index=0&id=8e798ba8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e798ba8",
  null
  
)

export default component.exports